import { useUserInfo } from "@/api/user";

export function useUserID(): string {
  const { data: userInfo } = useUserInfo();

  return userInfo?.user?.id ?? "";
}
